/* Brand My Cap – product page configurators: branding (stock caps), on-demand (cap manufacturing), branding on request, custom socks */
(function () {
  'use strict';
  var B = window.BMC;
  if (!B) return;
  var METHODS = B.METHODS, POSITIONS = B.POSITIONS, method = B.method, money = B.money, setupFees = B.setupFees;

  /* Vector files are preferred; JPG / PNG are accepted with a warning that a redraw fee may apply */
  function isVector(f) { return /\.(ai|eps|svg|pdf)$/i.test(f.name); }
  function fileOk(f) { return /\.(ai|eps|svg|pdf|jpe?g|png)$/i.test(f.name); }
  var RASTER_WARN = 'This file isn’t a vector format (AI, EPS, SVG or PDF). We can still use it, but we may need to redraw it, so a design/redraw fee might be added to your quote.';
  function fileWarn(fi) {
    var w = fi.parentNode.querySelector('.bmc-file-warn');
    var f = fi.files && fi.files[0];
    var show = !!(f && fileOk(f) && !isVector(f));
    if (show && !w) {
      w = document.createElement('p');
      w.className = 'bmc-file-warn';
      w.setAttribute('role', 'status');
      w.style.cssText = 'margin:.6rem 0 0;padding:.8rem 1rem;border-left:3px solid #f5e61e;background:rgba(245,230,30,.08);font-size:1.3rem;line-height:1.5;';
      w.textContent = RASTER_WARN;
      fi.parentNode.appendChild(w);
    }
    if (w) w.hidden = !show;
  }
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (t && t.matches && t.matches('[data-bmc-config] input[type="file"], [data-bmc-req] input[type="file"], [data-bmc-od] input[type="file"]')) fileWarn(t);
  });
  var BAD_FILE = 'upload the logo as AI, EPS, SVG, PDF, JPG or PNG.';

  function qtyOf(form) {
    var q = form.querySelector('[name="quantity"]') || document.querySelector('.product-form__quantity [name="quantity"]');
    return { el: q, val: Math.max(1, parseInt(q && q.value, 10) || 1) };
  }
  function idInput(form) { return form.querySelector('[name="id"]'); }
  function row(label, value, cls) {
    return '<div class="bmc-bd__row' + (cls ? ' ' + cls : '') + '"><span>' + label + '</span><span>' + value + '</span></div>';
  }
  function errorsBox(root, errs) {
    var box = root.querySelector('[data-bmc-errors]');
    if (!box) return;
    box.innerHTML = errs.map(function (t) { return '<p>' + t + '</p>'; }).join('');
    box.hidden = !errs.length;
  }
  function guardSubmit(form, root, validate) {
    var submit = form.querySelector('[type="submit"][name="add"]');
    var guard = function (e) {
      var errs = validate();
      if (errs.length) {
        e.preventDefault(); e.stopImmediatePropagation();
        errorsBox(root, errs);
        root.scrollIntoView({ behavior: 'smooth', block: 'start' });
        return false;
      }
      errorsBox(root, []);
    };
    if (submit) submit.addEventListener('click', guard, true);
    form.addEventListener('submit', guard, true);
  }
  function watchQty(form, fn) {
    form.addEventListener('change', function () { setTimeout(fn, 30); });
    form.addEventListener('input', function () { setTimeout(fn, 30); });
    document.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('.quantity__button')) setTimeout(fn, 30);
    });
  }
  function watchVariant(fn) {
    document.addEventListener('change', function (e) {
      if (e.target.closest && e.target.closest('variant-radios, variant-selects')) setTimeout(fn, 120);
    });
    window.addEventListener('popstate', function () { setTimeout(fn, 120); });
  }

  /* ================= Quantity price tiers (Flexfit caps, socks) =================
     Variants are Colour x Quantity band (e.g. 1–12 / 13–99 / 100+). The band is chosen from the quantity typed in;
     the band picker itself is hidden. The price is per colour, as the supplier charges it. */
  function tierSetup(root, form, variants) {
    if (!root.hasAttribute('data-bmc-tiered')) return null;
    document.querySelectorAll('[name="options[Quantity]"]').forEach(function (el) {
      var box = el.closest('.product-form__input') || el.closest('fieldset');
      if (box) box.style.display = 'none';
    });
    var tt = root.querySelector('[data-bmc-tt]'), tq = root.querySelector('[data-bmc-tq]');
    var unit = root.getAttribute('data-bmc-unit') || 'cap';
    var min = Number(root.getAttribute('data-bmc-tmin')) || 0;
    var q0 = qtyOf(form);
    if (min && q0.el) { q0.el.min = min; if ((parseInt(q0.el.value, 10) || 0) < min) q0.el.value = min; }
    function th(v) { return parseInt(String(v.option2).replace(/[^0-9].*$/, ''), 10) || 1; }
    return function sync() {
      var inp = idInput(form), id = inp ? Number(inp.value) : 0, cur = variants[0];
      variants.forEach(function (v) { if (v.id === id) cur = v; });
      var vs = variants.filter(function (v) { return v.option1 === cur.option1; });
      var ths = vs.map(th);
      var qty = qtyOf(form).val, t = 0;
      ths.forEach(function (x, i) { if (qty >= x) t = i; });
      var v = vs[t] || cur;
      if (inp && Number(inp.value) !== v.id) inp.value = v.id;
      if (tt) tt.value = vs.map(function (x) { return x.id; }).join(',');
      if (tq) tq.value = ths.join(',');
      var scope = form.closest('.product__info-wrapper, .product__info-container, product-info') || document;
      scope.querySelectorAll('.price__regular .price-item--regular, .price__sale .price-item--sale').forEach(function (el) { el.textContent = money(v.price / 100); });
      var rows = vs.map(function (x, i) {
        var lab = String(x.option2).replace(/\s*[–-]\s*/, ' – ');
        return '<tr' + (i === t ? ' class="is-current"' : '') + '><td>' + lab + ' ' + unit + 's</td><td>' + money(x.price / 100) + ' each</td></tr>';
      }).join('');
      var next = '';
      if (t < vs.length - 1) next = '<p class="bmc-bd__note">Add ' + (ths[t + 1] - qty) + ' more' + (unit === 'cap' ? ' of this colour' : '') + ' (' + ths[t + 1].toLocaleString('en-ZA') + '+) and the price drops to ' + money(vs[t + 1].price / 100) + ' per ' + unit + '.</p>';
      var html = '<div class="bmc-tiers"><h4>Price per ' + unit + (unit === 'cap' ? ' – the more of a colour you order, the less you pay' : ' – the more you order, the less you pay') + '</h4><table class="bmc-od__tiers"><tbody>' + rows + '</tbody></table>' + next + '</div>';
      return { v: v, html: html, qty: qty, min: min };
    };
  }

  /* ================= Branding method picker with example previews ================= */
  var IMG = 'https://cdn.shopify.com/s/files/1/0785/8277/5865/files/';
  var EXAMPLES = {
    'flat-emb': ['bm-flat-embroidery.png', 'Thread stitched flat into the fabric. Neat, durable, premium.'],
    '3d-emb': ['bm-3d-embroidery.png', 'Embroidery raised over a foam underlay for a bold, raised look.'],
    'dtf': ['bm-dtf-print.png', 'Full-colour direct-to-film print with sharp detail.'],
    'pu': ['bm-pu-heat-transfer.png', 'Polyurethane transfer heat-pressed on. Crisp and flexible.'],
    'dtf-patch': ['bm-dtf-print-patch.png', 'Full-colour print on a patch, with strong colours.'],
    'raised-dtf': ['bm-raised-dtf-patch.png', 'DTF patch with a slightly raised effect.'],
    'flat-emb-patch': ['bm-flat-embroidered-patch.png', 'Traditional embroidered badge.'],
    '3d-emb-patch': ['bm-3d-embroidered-patch.png', 'Raised embroidered badge.'],
    '3d-pu': ['bm-3d-pu-print.png', 'Raised print with a rubberised feel.'],
    'leather': ['bm-leather-patch.png', 'Logo laser-engraved into leather.'],
    'flock': ['bm-cut-flock.png', 'Suede-like, velvety print.'],
    'matte': ['bm-matte-patch.png', 'Printed fabric patch with a non-shiny finish.'],
    'debossed': ['bm-debossed-patch.png', 'Logo pressed into the patch surface.'],
    'reflective': ['bm-reflective-print.png', 'Print that reflects light at night.'],
    'rubber': ['bm-rubber-patch.png', 'Sturdy, flexible rubber badge with a bold finish.'],
    'silicone': ['bm-silicone-patch.png', 'Soft, smooth silicone badge with a premium feel.'],
    'sublimation': ['bm-sublimated-gaiter.png', 'All-over full-colour print for neck gaiters and buffs.'],
    'tpu': ['bm-tpu.png', 'Flexible, durable thermoplastic branding with a sleek, modern look.'],
    'woven-patch': ['bm-woven-patch.png', 'Woven detail that handles complex logos with high clarity.'],
    'satin-label': ['bm-satin-label.png', 'Smooth, glossy woven label.'],
    'woven-label': ['bm-woven-label.png', 'Woven fabric label for subtle, professional branding.'],
    'deboss-strap': ['bm-debossed-strap.png', 'Logo or text pressed into the back strap.'],
    'jibbitz': ['bm-jibbitz.png', 'Custom moulded add-ons that clip onto the cap.'],
    'ff-flat-emb': ['bm-flat-embroidery.png', 'Stitched directly onto the cap for a smooth, low-profile finish. Front, back or sides.'],
    'ff-3d-emb': ['bm-3d-embroidery.png', 'Foam under the stitching for a raised, bold look. Best for thick fonts on the front panel.'],
    'ff-flat-badge': ['bm-flat-embroidered-patch.png', 'Your design stitched onto a badge, then sewn onto the cap – ideal for fine detail.'],
    'ff-dtf': ['bm-dtf-print.png', 'Full-colour print heat-pressed onto the cap – bold colours and fine detail.'],
    'ff-rubber': ['bm-rubber-patch.png', 'Micro-injection rubber badge with raised 3D detail you can feel.'],
    'ff-pu': ['bm-pu-heat-transfer.png', 'Durable PU patch with a clean, modern finish.'],
    'ff-embossed': ['bm-debossed-patch.png', 'Badge with your logo pressed into the surface for a premium, textured look.'],
    'ff-silicone': ['bm-silicone-patch.png', 'Flat silicone transfer with a soft, smooth, flexible finish.']
  };
  var openPicker = null;
  document.addEventListener('click', function (e) {
    if (openPicker && !openPicker.contains(e.target)) openPicker._close();
  });
  function enhanceMethodSelect(sel) {
    if (sel.dataset.bmcPicker) return;
    sel.dataset.bmcPicker = '1';
    var wrap = document.createElement('div');
    wrap.className = 'bmc-ms';
    wrap.innerHTML = '<button type="button" class="bmc-ms__btn" aria-haspopup="listbox" aria-expanded="false"><span class="bmc-ms__val"></span></button>' +
      '<div class="bmc-ms__pop" hidden><ul class="bmc-ms__list" role="listbox"></ul>' +
      '<div class="bmc-ms__prev" aria-hidden="true"><div class="bmc-ms__img"><img alt="" width="312" height="164"></div><strong></strong><span></span></div></div>';
    sel.parentNode.insertBefore(wrap, sel.nextSibling);
    sel.classList.add('bmc-ms__native');
    sel.tabIndex = -1;
    var btn = wrap.querySelector('.bmc-ms__btn'), val = wrap.querySelector('.bmc-ms__val');
    var pop = wrap.querySelector('.bmc-ms__pop'), list = wrap.querySelector('.bmc-ms__list');
    var pImg = wrap.querySelector('.bmc-ms__prev img'), pName = wrap.querySelector('.bmc-ms__prev strong'), pText = wrap.querySelector('.bmc-ms__prev span');
    var opts = [].slice.call(sel.options).filter(function (o) { return o.value; });
    list.innerHTML = opts.map(function (o, i) {
      return '<li><button type="button" role="option" data-i="' + i + '" data-v="' + o.value + '">' + o.textContent + '</button></li>';
    }).join('');
    var items = [].slice.call(list.querySelectorAll('[data-v]'));
    function preview(k, label) {
      var ex = EXAMPLES[k];
      if (!ex) return;
      pImg.src = IMG + ex[0] + '?width=640';
      pName.textContent = label;
      pText.textContent = ex[1];
    }
    function sync() {
      var o = sel.options[sel.selectedIndex];
      val.textContent = o && o.value ? o.textContent : 'Choose a method…';
      wrap.classList.toggle('is-empty', !sel.value);
      btn.disabled = sel.disabled;
      items.forEach(function (b) { b.setAttribute('aria-selected', b.dataset.v === sel.value ? 'true' : 'false'); });
    }
    function close() {
      pop.hidden = true;
      btn.setAttribute('aria-expanded', 'false');
      wrap.classList.remove('is-open');
      if (openPicker === wrap) openPicker = null;
    }
    function open() {
      if (openPicker && openPicker !== wrap) openPicker._close();
      pop.hidden = false;
      pop.style.left = '0px';
      btn.setAttribute('aria-expanded', 'true');
      wrap.classList.add('is-open');
      openPicker = wrap;
      var cur = items.filter(function (b) { return b.dataset.v === sel.value; })[0] || items[0];
      preview(cur.dataset.v, cur.textContent);
      /* keep the popup inside the screen */
      var r = pop.getBoundingClientRect(), over = r.right - (document.documentElement.clientWidth - 12);
      if (over > 0) pop.style.left = (-Math.min(over, r.left - 12)) + 'px';
      cur.focus();
    }
    function choose(b) {
      sel.value = b.dataset.v;
      sel.dispatchEvent(new Event('change', { bubbles: true }));
      sync();
      close();
      btn.focus();
    }
    wrap._close = close;
    sel._bmcSync = sync;
    btn.addEventListener('click', function () { if (pop.hidden) open(); else close(); });
    btn.addEventListener('keydown', function (e) { if (e.key === 'ArrowDown' || e.key === 'ArrowUp') { e.preventDefault(); open(); } });
    items.forEach(function (b, i) {
      b.addEventListener('mouseenter', function () { preview(b.dataset.v, b.textContent); });
      b.addEventListener('focus', function () { preview(b.dataset.v, b.textContent); });
      b.addEventListener('click', function () { choose(b); });
      b.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowDown') { e.preventDefault(); (items[i + 1] || items[0]).focus(); }
        else if (e.key === 'ArrowUp') { e.preventDefault(); (items[i - 1] || items[items.length - 1]).focus(); }
        else if (e.key === 'Escape') { e.preventDefault(); close(); btn.focus(); }
        else if (e.key === 'Tab') close();
      });
    });
    sel.addEventListener('change', sync);
    sync();
  }

  /* ================= Branding configurator (stock caps) ================= */
  function initBranding(root) {
    if (root.dataset.bmcReady) return;
    var form = root.closest('form');
    if (!form) return;
    root.dataset.bmcReady = '1';
    var variants = JSON.parse(root.querySelector('[data-bmc-variants]').textContent);
    var rows = [].slice.call(root.querySelectorAll('[data-bmc-row]'));
    var none = root.querySelector('[data-bmc-none]');
    var body = root.querySelector('[data-bmc-body]');
    var summary = root.querySelector('[name="properties[Branding]"]');
    var addBtn = root.querySelector('[data-bmc-add-position]');
    var set = root.getAttribute('data-bmc-set') || '';
    var LIST = METHODS.filter(function (m) { return (m.set || '') === set; });
    var tierSync = tierSetup(root, form, variants);

    root.querySelectorAll('select[data-bmc-method]').forEach(function (sel) {
      LIST.forEach(function (m) {
        var o = document.createElement('option');
        o.value = m.k;
        o.textContent = m.n + (m.min && !m.set ? ' (min ' + m.min.toLocaleString('en-ZA') + ')' : '');
        sel.appendChild(o);
      });
    });
    root.querySelectorAll('select[data-bmc-method]').forEach(enhanceMethodSelect);
    root.querySelectorAll('select[data-bmc-position]').forEach(function (sel, i) {
      POSITIONS.forEach(function (p) {
        var o = document.createElement('option'); o.value = p; o.textContent = p; sel.appendChild(o);
      });
      sel.selectedIndex = Math.min(i, POSITIONS.length - 1);
    });

    function setRowEnabled(r, on) {
      r.hidden = !on;
      r.querySelectorAll('input, select, textarea').forEach(function (el) { el.disabled = !on; });
    }
    function syncRows() {
      var off = none.checked;
      body.hidden = off;
      rows.forEach(function (r, i) {
        var on = !off && (i === 0 || r.dataset.open === '1');
        setRowEnabled(r, on);
        var later = r.querySelector('[data-bmc-later]');
        var file = r.querySelector('[data-bmc-file]');
        if (file) {
          var hideFile = later && later.checked;
          file.hidden = hideFile;
          var fi = file.querySelector('input[type="file"]');
          if (fi) { fi.disabled = !on || hideFile; if (hideFile) { fi.value = ''; fileWarn(fi); } }
        }
      });
      root.querySelectorAll('[data-bmc-body] [name="properties[Notes]"]').forEach(function (el) { el.disabled = off; });
      if (addBtn) addBtn.hidden = off || rows.every(function (r, i) { return i === 0 || r.dataset.open === '1'; });
    }
    if (addBtn) addBtn.addEventListener('click', function () {
      for (var i = 1; i < rows.length; i++) if (rows[i].dataset.open !== '1') { rows[i].dataset.open = '1'; break; }
      syncRows(); update();
    });
    root.querySelectorAll('[data-bmc-remove]').forEach(function (b) {
      b.addEventListener('click', function () {
        var r = b.closest('[data-bmc-row]');
        r.dataset.open = '0';
        r.querySelectorAll('select[data-bmc-method]').forEach(function (s) { s.value = ''; });
        syncRows(); update();
      });
    });

    function currentVariant() {
      var inp = idInput(form), id = inp ? Number(inp.value) : 0;
      for (var i = 0; i < variants.length; i++) if (variants[i].id === id) return variants[i];
      return variants[0];
    }

    function update() {
      var tier = tierSync ? tierSync() : null;
      var q = qtyOf(form).val;
      var v = tier ? tier.v : currentVariant();
      var capPrice = v ? v.price / 100 : 0;
      var sold = v && v.available === false;
      root.classList.toggle('is-soldout', !!sold);
      var so = root.querySelector('.bmc-soldout');
      if (!so) {
        so = document.createElement('div');
        so.className = 'bmc-soldout';
        so.innerHTML = '<strong>This cap is currently sold out.</strong><span>Choose another colour, or send us a message and we’ll let you know when it’s back in stock.</span>';
        root.insertBefore(so, root.firstChild);
      }
      so.hidden = !sold;
      var off = none.checked;
      root.querySelectorAll('select[data-bmc-method]').forEach(function (s) { if (s._bmcSync) s._bmcSync(); });
      var setup = 0, perCapKnown = 0, quoted = false, sampled = false, estimated = false, warn = [], parts = [], brandRows = '', rk = {}, setupItems = [], lead = 0;
      rows.forEach(function (r, i) {
        var hm = r.querySelector('[data-bmc-hm]'), hp = r.querySelector('[data-bmc-hp]');
        var m = (!off && !r.hidden) ? method(r.querySelector('select[data-bmc-method]').value) : null;
        var pos = r.querySelector('select[data-bmc-position]').value;
        if (hm) hm.value = m ? m.k : '';
        if (hp) hp.value = m ? pos : '';
        if (!m) return;
        var nm = (r.querySelector('[data-bmc-logo-name]').value || '').trim();
        parts.push(m.n + ' – ' + pos + (nm ? ' (' + nm + ')' : ''));
        rk[m.fee] = (rk[m.fee] || 0) + 1;
        if (m.fee === 'quote') setupItems.push([pos + ' – ' + m.n + ' setup', 'On quote']);
        setupFees(m, q, i === 0, rk[m.fee]).forEach(function (f) {
          setup += f.amt;
          setupItems.push([pos + ' – ' + (/^Digitising/.test(f.label) ? 'Logo digitising for embroidery (under 50 caps)' : m.n + ' setup'), money(f.amt)]);
        });
        if (B.sampled ? B.sampled(m) : m.fee !== 'quote') sampled = true;
        if (m.lead && m.lead > lead) lead = m.lead;
        var pc = B.brandPrice(m, pos, q);
        var known = pc != null;
        if (known) { perCapKnown += pc; estimated = true; } else quoted = true;
        brandRows += row('Branding on the ' + pos.toLowerCase() + ' <small>(' + m.n + (known && !m.set ? ', estimate' : '') + ')</small>', known ? money(pc) + ' per cap' : 'Confirmed on quote');
        if (m.min && q < m.min) warn.push(m.n + ' has a minimum of ' + m.min.toLocaleString('en-ZA') + ' caps across your order. You can combine different caps and colours with the same branding to reach it.');
        if (m.note) warn.push(m.n + ': ' + m.note + '.');
      });
      summary.value = off ? 'No branding' : parts.join(' + ');

      var html = tier ? tier.html : '';
      html += row('Cap price <small>(excluding branding)</small>', money(capPrice));
      /* One sample cap for approval before production: the cap plus its branding */
      var sample = (!off && sampled) ? capPrice + perCapKnown : 0;
      var ss = off ? 0 : setup + sample;
      if (!off && parts.length) {
        if (ss > 0 || setupItems.length) {
          var subs = setupItems.slice();
          if (sample) subs.push(['Sample cap for your approval (incl. branding)', money(sample)]);
          html += row('Branding setup &amp; sampling', money(ss) + ' ÷ ' + q + (q === 1 ? ' cap' : ' caps') + ' = ' + money(ss / q) + ' per cap', 'bmc-bd__row--setup');
          html += '<ul class="bmc-bd__subs">' + subs.map(function (t) { return '<li><span>' + t[0] + '</span><span>' + t[1] + '</span></li>'; }).join('') + '</ul>';
        }
        html += brandRows;
        html += row('Branded cap price <small>(' + (ss > 0 ? 'including setup and sampling' : 'cap + branding') + ')</small>', money(capPrice + perCapKnown + ss / q) + ' per cap', 'bmc-bd__row--branded');
      }
      var total = capPrice * q + (off ? 0 : ss + perCapKnown * q);
      html += row('Total for your order <small>(' + q + (q === 1 ? ' cap' : ' caps') + ', ex VAT)</small>', money(total), 'bmc-bd__row--total');
      if (!off && parts.length && set === 'ff') {
        html += '<p class="bmc-bd__note">No setup fees. Branding is charged per cap and gets cheaper at 100+ and 200+ caps with the same logo. Minimum 72 branded caps across your order.' +
          (lead ? ' Lead time: about ' + lead + ' working days once your artwork is approved and payment is received.' : '') + '</p>';
      } else if (!off && parts.length && (quoted || estimated)) html += '<p class="bmc-bd__note">' +
        (estimated ? 'Branding prices are estimates based on recent orders and are confirmed on your quote' + (quoted ? '; branding marked “Confirmed on quote” is added then' : '') + '. ' : 'Plus the branding cost per cap, which we confirm on your quote. ') +
        'Setup fees are added to your cart automatically.</p>';
      root.querySelector('[data-bmc-price]').innerHTML = html;
      var w = root.querySelector('[data-bmc-warn]');
      w.innerHTML = warn.map(function (t) { return '<p>' + t + '</p>'; }).join('');
      w.hidden = !warn.length;
    }

    none.addEventListener('change', function () { syncRows(); update(); });
    root.addEventListener('change', function (e) {
      if (e.target.matches('[data-bmc-later]')) syncRows();
      update();
    });
    root.addEventListener('input', update);
    watchQty(form, update);
    document.addEventListener('bmc:variant', update);
    watchVariant(update);

    guardSubmit(form, root, function () {
      var errs = [];
      if (none.checked) return errs;
      rows.forEach(function (r, i) {
        if (r.hidden) return;
        var n = 'Position ' + (i + 1) + ': ';
        if (!r.querySelector('select[data-bmc-method]').value) errs.push(n + 'choose a branding method.');
        if (!(r.querySelector('[data-bmc-logo-name]').value || '').trim()) errs.push(n + 'give this logo a name (e.g. “Company logo”).');
        var later = r.querySelector('[data-bmc-later]');
        var fi = r.querySelector('input[type="file"]');
        if (fi && fi.files.length && !fileOk(fi.files[0])) errs.push(n + BAD_FILE);
        if (fi && !fi.files.length && !(later && later.checked)) errs.push(n + 'upload the logo, or tick “I’ll send this logo later”.');
      });
      update();
      return errs;
    });
    syncRows();
    update();
  }

  /* ================= On-demand configurator (cap manufacturing) ================= */
  function initOnDemand(root) {
    if (root.dataset.bmcReady) return;
    var form = root.closest('form');
    if (!form) return;
    root.dataset.bmcReady = '1';
    document.documentElement.classList.add('bmc-od-page');
    var variants = JSON.parse(root.querySelector('[data-bmc-variants]').textContent);
    var styles = [], byStyle = {};
    variants.forEach(function (v) {
      var s = v.option1;
      if (!byStyle[s]) { byStyle[s] = []; styles.push(s); }
      byStyle[s].push(v);
    });
    styles.forEach(function (s) {
      byStyle[s].sort(function (a, b) { return B.OD_TIERS.indexOf(tierMin(a.option2)) - B.OD_TIERS.indexOf(tierMin(b.option2)); });
    });
    function tierMin(label) { return parseInt(String(label).replace(/[^0-9].*$/, ''), 10); }
    function img(v, w) {
      var src = v.featured_image && v.featured_image.src;
      if (!src) return '';
      return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
    }

    var q = qtyOf(form);
    if (q.el) { q.el.min = B.OD_TIERS[0]; if ((parseInt(q.el.value, 10) || 0) < B.OD_TIERS[0]) q.el.value = B.OD_TIERS[0]; }

    var grid = root.querySelector('[data-bmc-od-styles]');
    grid.innerHTML = styles.map(function (s, i) {
      return '<label class="bmc-od__style"><input type="radio" name="bmc-od-style" value="' + i + '"' + (i === 0 ? ' checked' : '') + '>' +
        '<span class="bmc-od__card"><img src="' + img(byStyle[s][0], 300) + '" alt="' + s.replace(/"/g, '&quot;') + '" loading="lazy" width="150" height="150">' +
        '<span class="bmc-od__name">' + s + '</span></span></label>';
    }).join('');

    var styleIdx = 0;
    var urlV = Number(new URLSearchParams(location.search).get('variant'));
    if (urlV) styles.forEach(function (s, i) { if (byStyle[s].some(function (v) { return v.id === urlV; })) styleIdx = i; });
    var radios = grid.querySelectorAll('input[type="radio"]');
    if (radios[styleIdx]) radios[styleIdx].checked = true;

    function update() {
      var qty = qtyOf(form).val;
      var s = styles[styleIdx], vs = byStyle[s];
      var t = B.odTier(qty), v = vs[t] || vs[0];
      var inp = idInput(form);
      if (inp && Number(inp.value) !== v.id) {
        inp.value = v.id;
        document.dispatchEvent(new CustomEvent('bmc:variant', { detail: { id: v.id } }));
      }
      root.querySelector('[name="properties[_bmc_style]"]').value = s;
      root.querySelector('[name="properties[Style]"]').value = s;
      root.querySelector('[name="properties[_bmc_tv]"]').value = vs.map(function (x) { return x.id; }).join(',');

      var ex = document.querySelector('.bmc-od-tiers');
      if (!ex) {
        ex = document.createElement('div');
        ex.className = 'bmc-od-tiers';
        var anchor = document.querySelector('.bmc-pg') || document.querySelector('media-gallery');
        if (anchor) anchor.parentNode.insertBefore(ex, anchor.nextSibling); else root.insertBefore(ex, root.firstChild);
      }
      ex.innerHTML = '<h4>Price per unit – ' + s + '</h4><table class="bmc-od__tiers"><thead><tr><th>Quantity</th><th>Price each</th></tr></thead><tbody>' +
        vs.map(function (x, i) { return '<tr' + (i === t ? ' class="is-current"' : '') + '><td>' + B.OD_TIER_LABELS[i] + '</td><td>' + money(x.price / 100) + '</td></tr>'; }).join('') +
        '</tbody></table><p class="bmc-od__small">Prices exclude VAT. Sample: ' + money(B.OD_SAMPLE) + ' per style.</p>';

      var design = root.querySelector('[name="properties[Design]"]:checked');
      var dfee = design && /^Let/i.test(design.value) ? B.OD_DESIGN : 0;
      var each = v.price / 100;
      var html = row('Sample (once per style)', money(B.OD_SAMPLE));
      html += row('Price per ' + (/visor/i.test(s) ? 'visor' : /cap/i.test(s) ? 'cap' : 'hat') + ' <small>(' + B.OD_TIER_LABELS[t] + ' units)</small>', money(each));
      if (dfee) html += row('Design fee <small>(once per style)</small>', money(dfee)) + '<p class="bmc-bd__note">' + B.OD_DESIGN_TEXT + '</p>';
      html += row('Total for your order <small>(' + qty + ' units, ex VAT)</small>', money(each * qty + B.OD_SAMPLE + dfee), 'bmc-bd__row--total');
      if (t < B.OD_TIERS.length - 1) html += '<p class="bmc-bd__note">Order ' + B.OD_TIERS[t + 1].toLocaleString('en-ZA') + ' or more and the price drops to ' + money(vs[t + 1].price / 100) + ' each.</p>';
      root.querySelector('[data-bmc-price]').innerHTML = html;
    }
    grid.addEventListener('change', function (e) {
      if (e.target.name === 'bmc-od-style') { styleIdx = Number(e.target.value); update(); }
    });
    root.addEventListener('change', function (e) {
      if (e.target.matches('[name="properties[Design]"]')) {
        var own = e.target.value.indexOf('myself') > -1;
        root.querySelector('[data-bmc-od-own]').hidden = !own;
        update();
      }
    });
    watchQty(form, update);
    guardSubmit(form, root, function () {
      var errs = [];
      if (qtyOf(form).val < B.OD_TIERS[0]) errs.push('The minimum is ' + B.OD_TIERS[0] + ' units.');
      if (!root.querySelector('[name="properties[Design]"]:checked')) errs.push('Choose who will do the design.');
      var fi = root.querySelector('input[type="file"]');
      if (fi && fi.files.length && !fileOk(fi.files[0])) errs.push('Please ' + BAD_FILE);
      update();
      return errs;
    });
    update();
  }

  /* ================= Custom socks (knitted to the client's design, price bands, minimum order) ================= */
  function initSocks(root) {
    var form = root.closest('form');
    if (!form) return;
    var variants = JSON.parse(root.querySelector('[data-bmc-variants]').textContent);
    var tierSync = tierSetup(root, form, variants);
    function update() {
      var tier = tierSync ? tierSync() : null;
      var q = qtyOf(form).val;
      var v = tier ? tier.v : variants[0];
      var each = v ? v.price / 100 : 0;
      var html = tier ? tier.html : '';
      html += row('Price per pair', money(each));
      html += row('Total for your order <small>(' + q + (q === 1 ? ' pair' : ' pairs') + ', ex VAT)</small>', money(each * q), 'bmc-bd__row--total');
      html += '<p class="bmc-bd__note">We send you a free design mock-up to approve before production. Lead time and delivery are confirmed on your quote.</p>';
      root.querySelector('[data-bmc-price]').innerHTML = html;
    }
    watchQty(form, update);
    watchVariant(update);
    guardSubmit(form, root, function () {
      var errs = [];
      var min = Number(root.getAttribute('data-bmc-tmin')) || 0;
      if (min && qtyOf(form).val < min) errs.push('The minimum order is ' + min + ' pairs.');
      var fi = root.querySelector('input[type="file"]');
      if (fi && fi.files.length && !fileOk(fi.files[0])) errs.push('Please ' + BAD_FILE);
      update();
      return errs;
    });
    update();
  }

  /* ================= Branding on request (limited positions, e.g. BooYaa) ================= */
  function initRequest(root) {
    if (root.dataset.bmcReady) return;
    root.dataset.bmcReady = '1';
    if (root.hasAttribute('data-bmc-socks')) return initSocks(root);
    var form = root.closest('form');
    if (!form) return;
    var variants = JSON.parse(root.querySelector('[data-bmc-variants]').textContent);
    var val = root.querySelector('[data-bmc-req-value]'), flag = root.querySelector('[data-bmc-req-flag]');
    var more = root.querySelector('[data-bmc-req-more]');
    function choice() { var c = root.querySelector('[data-bmc-req-choice]:checked'); return c ? c.value : ''; }
    function update() {
      var c = choice(), want = c === 'brand';
      val.value = want ? 'Branding requested – Brand My Cap to contact client' : (c === 'plain' ? 'No branding' : '');
      flag.value = want ? '1' : '';
      flag.disabled = !want;
      more.hidden = !want;
      more.querySelectorAll('input, textarea').forEach(function (el) { el.disabled = !want; });
      var q = qtyOf(form).val;
      var inp = idInput(form), id = inp ? Number(inp.value) : 0, v = variants[0];
      variants.forEach(function (x) { if (x.id === id) v = x; });
      var cap = v ? v.price / 100 : 0;
      var html = row('Cap price', money(cap));
      if (want) html += row('Branding', 'Quoted after we contact you');
      html += row('Total for your order <small>(' + q + (q === 1 ? ' cap' : ' caps') + ', ex VAT)</small>', money(cap * q), 'bmc-bd__row--total');
      html += '<p class="bmc-bd__note">Stock is confirmed when you send your order request.' + (want ? ' We’ll contact you about the branding options before quoting.' : '') + '</p>';
      root.querySelector('[data-bmc-price]').innerHTML = html;
    }
    root.addEventListener('change', update);
    watchQty(form, update);
    watchVariant(update);
    guardSubmit(form, root, function () {
      var errs = [];
      if (!choice()) errs.push('Choose plain caps, or let us know you’re interested in branding.');
      var fi = root.querySelector('input[type="file"]');
      if (fi && !fi.disabled && fi.files.length && !fileOk(fi.files[0])) errs.push('Please ' + BAD_FILE);
      update();
      return errs;
    });
    update();
  }

  function boot() {
    document.querySelectorAll('[data-bmc-req]').forEach(initRequest);
    document.querySelectorAll('[data-bmc-config]').forEach(initBranding);
    document.querySelectorAll('[data-bmc-od]').forEach(initOnDemand);
  }
  document.addEventListener('bmc:config-ready', boot);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
